	/**
	 * Replaces format string tokens like "{0} in {1}", which are often used in i18n.
	 * @param subject - The string to format
	 * @param args - the partial strings to fill into string
	 * @returns String
	 */
export function format(subject : string, ...args : any[]) {
	return (subject || '').replace(/\{(\d+)\}/g, function(_str, i) {
		const result = args[parseInt(i, 10)];

		return typeof result === 'number' ? result : result || '';
	});
}

	/**
	 * Truncate a string to "roughly" the given length.
	 * Appending an elipsis if sentence is not finished.
	 * @param text - The string to truncate
	 * @param length - Length of desired string
	 * @returns String
	 */
export function truncate(text : string, length : number, elipsis = '…', overshootAllowance = 3) {

	if (text && text.length > length + overshootAllowance) {
		// Shorten the lead text and ...
		text = text.substr(0, length)
			// Remove trailing partial word
			.replace(/\s+[^\s\.]+$/, '')
			// Remove trailing interpunction
			.replace(/\s*[(:;,_-]?\s*$/, '');
		// If sentence is not finished
		if (!text.match(/\.$/)) {
			text += elipsis || '';
		}
	}

	return text;
}

export function plainTextFromHtml(text : string) {
	const dummyTag = document.createElement('div');
	dummyTag.innerHTML = text;

	return dummyTag.textContent!;
}




// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/string.ts